<template>
    <span>
        <b-button variant="primary" @click.stop="abrirModal()" class="ml-2">
            <span>
                <i class="fa fa-check-circle"></i>
                Avaliar Requisição
            </span>
        </b-button>

        <b-modal v-model="mostrarModal" centered>
            <div slot="modal-title">Avaliação da Requisição</div>

            <b-row>
                <b-col sm="12">
                    <p class="mb-3">
                        Selecione o status de avaliação da requisição:
                    </p>

                    <b-form-group label="Status de Avaliação:" class="mb-3">
                        <b-form-radio-group
                            v-model="statusAvaliacao"
                            :options="statusOptions"
                            name="statusAvaliacao"
                        ></b-form-radio-group>
                    </b-form-group>                    <b-form-group 
                        v-if="statusAvaliacao === 3" 
                        label="Justificativa da Reprovação:"
                        class="mb-3"
                    >
                        <b-form-textarea
                            v-model="justificativa"
                            placeholder="Informe a justificativa da reprovação..."
                            rows="4"
                            max-rows="6"
                            maxlength="1000"
                        ></b-form-textarea>
                        <small class="text-muted">
                            {{ justificativa.length }}/1000 caracteres
                        </small>
                        <small class="text-danger" v-if="statusAvaliacao === 3 && !justificativa">
                            A justificativa é obrigatória para reprovação
                        </small>
                    </b-form-group>

                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">Cancelar</b-button>
                <b-button 
                    variant="success" 
                    class="ml-2" 
                    :disabled="!validarFormulario()"
                    @click.stop="confirmarAvaliacao()"
                >
                    Confirmar Avaliação
                </b-button>
            </div>
        </b-modal>

    </span>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            statusAvaliacao: null,
            justificativa: '',
            statusOptions: [
                { text: 'Aprovada', value: 2 },
                { text: 'Reprovada', value: 3 }
            ]
        }
    },

    methods: {
        abrirModal() {
            this.statusAvaliacao = null
            this.justificativa = ''
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },        
        validarFormulario() {
            return this.statusAvaliacao && 
                   (this.statusAvaliacao !== 3 || this.justificativa.trim())
        },

        confirmarAvaliacao() {
            if (!this.validarFormulario()) {
                return
            }

            this.adicionarAvaliacaoGestorResponsavel()
            this.fecharModal()
        },

        adicionarAvaliacaoGestorResponsavel() {
            this.$store.dispatch('addRequest')
            
            const avaliacaoData = {
                statusAvaliacaoGestor: this.statusAvaliacao,
                justificativa: this.statusAvaliacao == 3 ? this.justificativa : null
            }

            RequisicoesServicos.adicionarAvaliacaoGestorResponsavelRequisicao(
                this.requisicao.idRequisicao, 
                avaliacaoData
            )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            const statusAvaliacaoAprovada = 2 ;
                            const mensagem = this.statusAvaliacao == statusAvaliacaoAprovada
                                ? 'Requisição aprovada com sucesso' 
                                : 'Requisição reprovada com sucesso'
                            
                            this.$toast.success(
                                mensagem,
                                'SUCESSO',
                                this.$toastConfig.success
                            )
                            
                            this.$emit('atualizarRequisicao')
                        } else {
                            this.$toast.error(
                                'Erro ao avaliar requisição',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                })
                .catch(() => {
                    this.$toast.error(
                        'Erro na comunicação com o servidor',
                        'ERROR',
                        this.$toastConfig.error
                    )
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
